<div class="warning-info">
  <div id="error-box" class="alert">
    <h2>{{ title }}</h2>
    <div>{{ message }}</div>
    <div *ngIf="showContact && contactEmail">
      Please contact <a href="mailto:{{ contactEmail }}">{{ contactEmail }}</a>
    </div>
  </div>
</div>
